import React from "react";
import request from "superagent";
import {URL_BIQ_DISCOVERY} from "../constants/Url";
import {timeoutRedirect, getColorStyle} from "./Util";
import {Link} from "react-router-dom";

export default class QvcBigDiscovery extends React.Component{
    constructor(props) {
        super(props)
        this.state = {
            results: []
        }
    }

    handleClickOpen(unit_id) {
        const {handleModalOpen} = this.props;
        handleModalOpen(unit_id)
    }
    
    componentWillMount() {
        this.fetchData();
    }

    fetchData() {
        request
            .get(URL_BIQ_DISCOVERY(this.props.access_token, this.props.gender, this.props.kit))
            .set('Content-Type', 'application/json')
            .end((err, res) => {
                if (err) {
                    console.log('error')
                }

                if (!res || !res.body.result) {
                    timeoutRedirect()
                }

                this.setState({
                    results: res.body.result
                })
            })
    }

    render() {
      return (
        <div className="wrap">
            <div className="titlearea">
                <h2>特別追加10項目</h2>
            </div>
            <div className="summary_table">
                <div className="inddata">
                    <table>
                        <thead>
                        <tr>
                            <th scope="col">検査項目</th>
                            <th scope="col" className="updown">結果</th>
                            <th scope="col">&nbsp;</th>
                        </tr>
                        </thead>
                        <tbody>
                        {(this.state.results.map(data =>
                            <tr key={Math.random()}>
                                <td className="name">{data.unit.name}</td>
                                <td className={`riskrevel ${getColorStyle(data.level_type, data.unit.id)}`}>{data.markup_level_name}</td>
                                <td className="detail">
                                    <Link to={{
                                        pathname: "/detail",
                                        state: { referer: "/add10" }
                                    }} ><div className="show_detail" onClick={this.handleClickOpen.bind(this, data.unit.id)}>詳細を見る</div></Link>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
      )
    }
}


// WEBPACK FOOTER //
// ./src/components/QvcBigDiscovery.js